import axios from "axios";

// export function getStudentList(co) {
//   const config = {
//     params: co,
//   };
//   return axios.get(process.env.VUE_APP_API_URL + "Class/studentlist", config);
// }

export function getStudentList(co) {
  const config = {
    params: co,
  };
  return axios.get(process.env.VUE_APP_API_URL + "Student/list", config);
}

export function finderStudentFiltered(co) {
  const config = {
    params: co,
  };
  return axios.get(process.env.VUE_APP_API_URL + "Student/findStudentFiltered", config);
}

export function loadStudentScores(co) {
  const config = {
    params: {
      userStudentId: co,
    },
  };
  return axios.get(process.env.VUE_APP_API_URL + "Student/studentScoresById", config);
}

export function getPaymentList(co) {
  const config = {
    params: co,
  };
  return axios.get(process.env.VUE_APP_API_URL + "Student/PaymentList", config);
}

export function getEvaluateCertificateStudentList(co) {
  const config = {
    params: co,
  };
  return axios.get(process.env.VUE_APP_API_URL + "Student/evaluatecertificatestudentsV2", config);
}

export function getStudentAssignmentList(co) {
  const config = {
    params: co,
  };
  return axios.get(process.env.VUE_APP_API_URL + "Student/listassignment", config);
}

export function getStudentById(studentId) {
  const config = {
    params: {
      usersId: studentId,
    },
  };
  return axios.get(process.env.VUE_APP_API_URL + "Class/studentinfo", config);
}

export function getStudentListByClassId(classId) {
  const config = {
    params: {
      classId: classId,
    },
  };
  return axios.get(process.env.VUE_APP_API_URL + "Student/studentbyclassid", config);
}

export function deleteStudentClass(data) {
  const config = {
    params: data,
  };
  return axios.delete(process.env.VUE_APP_API_URL + "Student/deletestudentbyclassid", config);
}

export function updateStudent(data) {
  const config = {
    headers: { "Content-Type": "multipart/form-data" },
  };
  return axios.put(process.env.VUE_APP_API_URL + "Student/update", data, config);
}

export function resetStudentRegistration(data) {
  return axios.post(process.env.VUE_APP_API_URL + "Student/resetregistration", data);
}

export function resetStudentPassword(data) {
  return axios.post(process.env.VUE_APP_API_URL + "Student/resetpassword", data);
}

export function changeCenter(data) {
  // const config = {
  //   params: data,
  // };
  return axios.post(process.env.VUE_APP_API_URL + "Student/changecenter", data);
}

export function changeCenterPeriod(data) {
  // const config = {
  //   params: data,
  // };
  return axios.post(process.env.VUE_APP_API_URL + "Student/changecenterPeriod", data);
}
